import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const doorAccessRoutes = {
  [ERouteMappingKeys.DOOR_ACCESS]: {
    id: "door-access",
    path: "/door-access",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/DoorAccess/Overview").then((p) => ({
          default: p.DoorAccessOverview,
        })),
      ),
      intercoms: lazy(() =>
        import("pages/Sections/DoorAccess/Intercom/Intercoms").then((p) => ({
          default: p.Intercoms,
        })),
      ),
      "touch-pass": lazy(() =>
        import("pages/Sections/DoorAccess/TouchPass").then((p) => ({
          default: p.TouchPass,
        })),
      ),
      readers: lazy(() =>
        import("pages/Sections/DoorAccess/Readers").then((p) => ({
          default: p.Readers,
        })),
      ),
      "starter-kits": lazy(() =>
        import("pages/Sections/DoorAccess/StarterKits").then((p) => ({
          default: p.StarterKits,
        })),
      ),
      "control-hubs": lazy(() =>
        import("pages/Sections/DoorAccess/ControlHubs").then((p) => ({
          default: p.ControlHubs,
        })),
      ),
    },
  },
};
